import { DataGrid } from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { SyncAlt } from "@mui/icons-material";

import { Box } from "@mui/material";

const theme = createTheme(ptBR);

const styles = {
  datagrid: {
    ".MuiDataGrid-iconButtonContainer": {
      visibility: "visible",
    },
    ".MuiDataGrid-sortIcon": {
      opacity: "inherit !important",
    },
    "& .even": {
      backgroundColor: "#D3E3EB",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#e1ebf0",
    },
    ".MuiDataGrid-columnHeader": {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#1E729F",
    },
    ".MuiDataGrid-row": {
      color: "#666666",
    },
    "&  .MuiTablePagination-root .MuiTablePagination-select": {
      width: "40px !important",
      padding: "10px 5px !important",
      textAlign: "start !important",
      textAlignLast: " initial !important",
    },
  },
};

export function SortedIcon() {
  return (
    <SyncAlt
      className="icon"
      sx={{ transform: "rotate(90deg)", color: "#1E729F" }}
      fontSize="small"
    />
  );
}

export default function TableGridData({
  rows,
  columns,
  disableColumnMenu = true,
  height = "500px",
  ...props
}) {
  return (
    <ThemeProvider theme={theme}>
      <Box position="relative" height={height} width="100%">
        <Box position="absolute" height={height} width="100%">
          <DataGrid
            sx={styles.datagrid}
            rows={rows}
            columns={columns}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "Mui-even"
                : "Mui-odd"
            }
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            columnVisibilityModel={{
              id: false,
            }}
            localeText={{
              noRowsLabel: "Não há dados a serem listados.",
              noResultsOverlayLabel: "Nenhum resultado encontrado.",
            }}
            pageSizeOptions={[5, 10, 15]}
            disableColumnMenu={disableColumnMenu}
            slots={{
              columnSortedDescendingIcon: SortedIcon,
              columnSortedAscendingIcon: SortedIcon,
            }}
            disableRowSelectionOnClick
            {...props}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
